import { useEffect, useState } from 'react';

const Time = () => {
  const [time, setTime] = useState('');

  useEffect(() => {
    const updateClock = () => {
      const now = new Date();
      const kyivTime = now.toLocaleTimeString('uk-UA', {
        timeZone: 'Europe/Kyiv',
        hour: '2-digit',
        minute: '2-digit',
      });
      setTime(kyivTime);
    };

    updateClock();
    const interval = setInterval(updateClock, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div className='kyiv-clock'>
        <h2>kyiv, Ukraine:</h2>
        <p>(GMT+3) {time}</p>
      </div>
    </>
  );
};

export default Time;
